module.exports = __webpack_public_path__ + "components/homepage-hero/static/hero-bg-94e0f988efcd2065f6a046d7b9b1d1cb.jpg";